import React from 'react';
import PropTypes from 'prop-types';

import { StyledWrapper, StyledDiv, StyledCollectionCardSpan } from './OkendoReviewStarsStyles';

var OkendoReviewStars = function OkendoReviewStars(_ref) {
  var okendoSnippet = _ref.okendoSnippet,
      okendoReviewCount = _ref.okendoReviewCount,
      isCollectionCard = _ref.isCollectionCard;
  return React.createElement(
    StyledWrapper,
    { isCollectionCard: isCollectionCard },
    React.createElement(StyledDiv, {
      isCollectionCard: isCollectionCard,
      dangerouslySetInnerHTML: { __html: okendoSnippet }
    }),
    isCollectionCard && okendoSnippet !== '<span></span>' && React.createElement(
      StyledCollectionCardSpan,
      null,
      '(',
      okendoReviewCount,
      ')'
    )
  );
};

OkendoReviewStars.propTypes = {
  okendoSnippet: PropTypes.string.isRequired,
  okendoReviewCount: PropTypes.string,
  isCollectionCard: PropTypes.bool
};

export default React.memo(OkendoReviewStars);